import { type FC } from "react";

import { EvaluationTypeEnum } from "@app_schema";

import { EvalTypeBadge } from "./eval_type_badge";
import type { ProcessRecordsStateContext } from "./process_records_context";
import { RecordFilePillStack } from "./records_file_pills";
import { RecordsStatusBar, RsbSpinnerIcon } from "./records_status_bar";

// Spinner-style RSB rendering for the non-follow-up `PROCESSING` state.
// The follow-up processing variant lives in `MERGING_FOLLOW_UP` and uses
// `FollowUpUploadStage` instead of a spinner.
export const ProcessingRecordsView: FC<{
  context: ProcessRecordsStateContext;
}> = ({ context }) => {
  const { id, projectID, evaluationType, variant, sourceFiles, recordReview } =
    context;

  const total = recordReview?.pagesCount ?? 0;
  const processed = recordReview?.processedPagesCount ?? 0;
  const progress = total > 0 ? (processed / total) * 100 : undefined;

  const body = (
    <RecordFilePillStack
      docs={sourceFiles}
      projectID={projectID}
      tone="upload"
    />
  );

  const evalType = evaluationType ?? EvaluationTypeEnum.Comprehensive;

  return (
    <RecordsStatusBar
      id={id}
      variant={variant}
      icon={<RsbSpinnerIcon />}
      title={recordReview?.title ?? "Processing records..."}
      subtitle={recordReview?.subtitle}
      badgeStack={<EvalTypeBadge type={evalType} />}
      body={body}
      progress={progress}
    />
  );
};
